import React, { useEffect} from "react"
import Header from "../../../components/navigation/Header"
import { useNavigate} from "react-router-dom"

export default function ConfirmStripeOnboarding(){
    const navigate = useNavigate()

    useEffect(()=>{
        document.title = "Stripe Onboarding Success!"
    },[])

    return (
        <div className="flex flex-col">
            <Header useCase="onboarding" />
            <section className="pt-40">
                <div className="flex flex-col justify-center items-center text-center">
                    <p className="text-xl font-semibold mx-auto px-4 text-center">
                        Please check your junk mail to confirm your account!
                    </p>
                    <p className="text-base font-semibold mx-auto px-4 mt-4 text-center">
                        You will receive any payouts via Stripe on a weekly basis.
                    </p>
                    <button
                        onClick={()=>navigate('/')}
                        className="form-btn mt-12 px-6"
                        aria-label="redirects to landing page"
                    >
                        Home
                    </button>
                </div>
            </section>
        </div>
    )
}